import artDirector from "@/assets/team/avatar_art_director.webp";
import contentWriter from "@/assets/team/avatar_content_writer.webp";
import creativeDirector from "@/assets/team/avatar_creative_director.webp";
import creativeStrategist from "@/assets/team/avatar_creative_strategist.webp";
import graphicDesigner from "@/assets/team/avatar_graphic_designer.webp";
import motionDesigner from "@/assets/team/avatar_motion_designer.webp";
import photographer from "@/assets/team/avatar_photographer.webp";
import socialMediaManager from "@/assets/team/avatar_social_media_manager.webp";
import videoEditor from "@/assets/team/avatar_video_editor.webp";

export type Agent = {
    name: string;
    role: string;
    image: string;
    specialty: string;
};

/**
 * Single source of truth for the Pixro AI creative crew.
 * Used by the AI Team page, the navbar AI Team menu, and any crew teasers.
 * The crew is "coming soon", so these are presentational only (no live links).
 */
export const aiCrew: Agent[] = [
    {
        name: "Vexo",
        role: "Creative Director",
        image: creativeDirector,
        specialty: "Owns the brief and keeps every asset on vision.",
    },
    {
        name: "Luma",
        role: "Art Director",
        image: artDirector,
        specialty: "Sets styling, palette, and visual direction.",
    },
    {
        name: "Nova",
        role: "Creative Strategist",
        image: creativeStrategist,
        specialty: "Finds the hooks, trends, and campaign angles that win.",
    },
    {
        name: "Sketch",
        role: "Graphic Designer",
        image: graphicDesigner,
        specialty: "Refines layouts, type, and final creatives.",
    },
    {
        name: "Flux",
        role: "Motion Designer",
        image: motionDesigner,
        specialty: "Adds motion and brings visuals to life.",
    },
    {
        name: "Koda",
        role: "Photographer",
        image: photographer,
        specialty: "Handles shoots, poses, lighting, and backgrounds.",
    },
    {
        name: "Loop",
        role: "Video Editor",
        image: videoEditor,
        specialty: "Cuts reels, product videos, and final ad edits.",
    },
    {
        name: "Quill",
        role: "Content Writer",
        image: contentWriter,
        specialty: "Writes prompts, scripts, captions, and ad copy.",
    },
    {
        name: "Buzz",
        role: "Social Media Manager",
        image: socialMediaManager,
        specialty: "Turns finished assets into platform-ready social content.",
    },
];
